/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import AdvCasino from '@views/AdvCasino'
// img
import AdvCasinoBannerImg01 from '@assets/images/casino/banner/casino-banner-01.png'
import AdvCasinoBannerPCImg01 from '@assets/images/casino/banner/casino-pc-banner-01.png'
import AdvCasinoBannerImg02 from '@assets/images/casino/banner/casino-banner-02.png'
// css
import { Button, CasinoBannerBtnStyle } from '@styles/button.style'

interface AdvCasinoBannerBtnProps {
  className?: string
}

const AdvCasinoBannerButton: React.FC<AdvCasinoBannerBtnProps> = (props: AdvCasinoBannerBtnProps) => {
  const { globalStore, routerStore } = useRootStore()
  const { className } = props

  const enabled = globalStore.getCasinoAdvertisementButtonDisplayEnabled()
  if (!enabled) {
    return (<Fragment/>)
  }

  const onClickAdvCasinoHandler = () => {
    if (className === 'sider-banner') {
      globalStore.setVisibleSideBar(false)
    }

    if (isMobile) {
      routerStore.push('/advCasino')
    } else {
      globalStore.addGeneralPopupProperties(<AdvCasino/>, '승부사카지노', { wrapClassName: '', className: 'adv-casino', isScroll: true, custom: false, clsBtn: false })
    }
  }

  let bannerImg

  if (className === 'sider-banner') {
    // 서랍메뉴 배너
    bannerImg = <img src={AdvCasinoBannerImg02} alt="승부사카지노 바카라 오픈!" style={{ height: '60px' }}/>
  } else if (className === 'pc-chat-banner') {
    // 채팅 PC버전 배너
    bannerImg = <img src={AdvCasinoBannerPCImg01} alt="승부사카지노 바카라 오픈!"/>
  } else {
    bannerImg = <img src={AdvCasinoBannerImg01} alt="승부사카지노 바카라 오픈!"/>
  }

  return (
    <Button TP css={CasinoBannerBtnStyle} className={className} onClick={onClickAdvCasinoHandler}>
      {bannerImg}
    </Button>
  )
}

export default observer(AdvCasinoBannerButton)
